export default __webpack_public_path__ + "static/media/duration.90d44df3.svg";